import { render, staticRenderFns } from "./LogoutListItem.vue?vue&type=template&id=2475765e"
import script from "./LogoutListItem.vue?vue&type=script&lang=ts"
export * from "./LogoutListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports